import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Methods } from '@/api/v1/cart'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

export type UpdateCartDTO = {
  data: Methods['put']['reqBody']
}

type MutationResponse = Awaited<ReturnType<typeof aspidaClient.v1.cart.$put>>

type UseUpdateCartOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, UpdateCartDTO>,
    'mutationFn'
  >
}

export const useUpdateCart = ({ config }: UseUpdateCartOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = ({ data }: UpdateCartDTO) => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.$put({ body: data })
    }
    return aspidaClient.v1.cart.$put({ body: data })
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.itemCount()),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, UpdateCartDTO>)
}
